<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="contratosElectricidad"
	[displayWith]="displayContratoElectricidad"
	[value]="selectedContratoElectricidad"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
